import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { FormType, FormItemType, FormItemDataType } from './types';

export const createForm = () => {
  return new FormGroup<FormType>({
    items: new FormArray([createItem()]),
  });
};

export const createItem = (initValues?: Partial<FormItemDataType>) => {
  return new FormGroup<FormItemType>({
    key: new FormControl(initValues?.key || null),
    value: new FormControl(initValues?.value || null),
  });
};
